// extracted by mini-css-extract-plugin
var _1 = "advantages__Amtci";
var _2 = "card__w1Tb6";
var _3 = "imageWrapper__eeMCT";
var _4 = "mainBlock__dcfYt";
var _5 = "row__PBFPp";
var _6 = "subtitle__oNxsG";
var _7 = "text__jqnFo";
export { _1 as "advantages", _2 as "card", _3 as "imageWrapper", _4 as "mainBlock", _5 as "row", _6 as "subtitle", _7 as "text" }
export default { "advantages": _1, "card": _2, "imageWrapper": _3, "mainBlock": _4, "row": _5, "subtitle": _6, "text": _7 }
